import { styled } from "styled-components";

export const FaqAccordionWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 96px 24px;
`;

export const FaqAccordionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  width: 100%;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  text-align: center;
  max-width: 1024px;
  margin: 0 auto;

  & a {
    color: ${({ theme }) => theme.colors.primary.default};
  }
`;

export const AccordionContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 1224px;
  padding: 48px;
  align-items: center;
  align-content: center;
  gap: 32px 94px;
  flex-wrap: wrap;
  gap: 12px;
  border-radius: 24px;
  background: ${({ theme }) => theme.colors.default[50]};
`;
